<template>
  <div id="app">
    <div 
    id="nav" 
    class="padding-vertical-sm-normal padding-horizontal-normal border-bottom border-ink-lighter-3 bg-white-base">
      <router-link to="/" class="logo">
        <span>storybox</span> <br>
        <span class="small">by <strong>bossabox</strong></span>
      </router-link>
      <b-button @clickOrEnter="$refs.printModal.toggleModal();" class="font-size-normal position-absolute position-right-normal" outline tiny>Exportar PDF <b-icon><icon-launch/></b-icon> </b-button>
    </div>
    <router-view/>
    <b-modal ref="printModal">
      <p class="align-center font-size-big">Para exportar esta tela como PDF, clique em Imprimir e altere a impressora/destino para <b>"Salvar como PDF"</b></p>
      <div class="margin-top-big display-flex justify-content-center">
        <b-button @clickOrEnter="$refs.printModal.hideModal().then(window.print);">Imprimir <b-icon><icon-print/></b-icon> </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BButton from "@/dls/components/Button.vue";
import BModal from "@/dls/components/Modal.vue";
import BIcon  from "@/dls/components/Icon.vue";
import IconLaunch from "@/dls/icons/icon-launch.svg";
import IconPrint from "@/dls/icons/icon-print.svg";

export default {
  components: {
    BButton,
    BModal,
    BIcon,
    IconLaunch,
    IconPrint
  },
  data() {
    return {window}
  }
}
</script>


<style lang="scss">
@import "@/dls/css/typography.scss";
@import "@/dls/css/spacing.scss";
@import "@/dls/css/_variables.scss";
@import "@/dls/css/colors-classes.scss";
@import "@/dls/css/elevation.scss";
@import "@/dls/css/grid.scss";
@import "@/dls/css/position.scss";

@import url('https://rsms.me/inter/inter.css');
html { font-family: 'Inter', sans-serif; }
@supports (font-variation-settings: normal) {
  html { font-family: 'Inter var', sans-serif; }
}
* {
  outline: none;
  &:focus {
    box-shadow: 0px 0px 5px 0 rgba(10,10,255,0.4);
    border-radius: 5px;
  }
}

body {
  margin: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#nav {
  display: flex;
  position: relative;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  a.logo {
    span {
      font-family: 'Montserrat', sans-serif;
      font-weight: bold;
      color: map-get($colors, 'blue-base');
      font-size: 1.75rem;
      display: inline-block;
    }
    span.small {
      display: inline-block;
      text-align: right;
      font-size: 0.875rem;
      color: map-get($colors, 'ink-lighter-1');
      font-weight: 400;
      strong {
        font-weight: 700;
      }
    }
  }
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
